import type { IModuleStrings, IRecordTypeDefinition } from '@platform/core/types';

/**
 * Однина типу записів для назви форми «Форма «Справа»» (заголовок редактора й остання крихта в «Налаштуваннях»): однина мовою інтерфейсу
 * (перейменування простору → пакет модуля → визначення), без однини — назва типу. Чиста функція.
 */
export function formSingular(strings: IModuleStrings, rt: IRecordTypeDefinition): string {
  return strings.entity(rt.key, 'singular', rt.singular ?? null) || strings.entity(rt.key, 'name', rt.name);
}
